var _excluded = ["text", "onClick"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React, { useContext } from "react";
import styled, { css } from "styled-components";
import BrandContext from "../../../../../../contexts/BrandContext";
import OnColorContext from "../../../../../../contexts/OnColorContext";
import pageHeaderBrandStyles from "../../../../../../theme/pageHeaderBrandStyles";
import getColor from "../../../../../../utils/getColor";
import getTextColor from "../../../../../../utils/getTextColor";
import space from "../../../../../../utils/space";
import transition from "../../../../../../utils/transition";
import TextAtm from "../../../../../atoms/TextAtm";
var ArrowSvg = function ArrowSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "m6 0 1.058 1.058L2.872 5.25H12v1.5H2.873l4.184 4.193L6 12 0 6l6-6Z"
  }));
};
ArrowSvg.defaultProps = {
  width: "12",
  height: "12",
  xmlns: "http://www.w3.org/2000/svg"
};
var Arrow = styled(ArrowSvg).withConfig({
  componentId: "sc-1jb0xuq-0"
})(function (_ref) {
  var $customColor = _ref.$customColor,
    $onColor = _ref.$onColor,
    theme = _ref.theme;
  return css(["", ";flex-shrink:0;margin-right:", ";fill:", ";"], transition("transform"), space(2), $customColor ? getColor(theme, $customColor) : getTextColor(theme, $onColor));
});
var Wrapper = styled.div.withConfig({
  componentId: "sc-1jb0xuq-1"
})(["display:inline-flex;align-items:center;cursor:pointer;&:hover{", "{transform:translateX(", ");}}"], Arrow, space(-0.5));
function BackLinkAtm(_ref2) {
  var text = _ref2.text,
    onClick = _ref2.onClick,
    restProps = _objectWithoutProperties(_ref2, _excluded);
  var onColor = useContext(OnColorContext);
  var navigationBackLinkCustomColor = pageHeaderBrandStyles[useContext(BrandContext)].navigationBackLinkCustomColor;
  return /*#__PURE__*/React.createElement(Wrapper, _extends({
    onClick: onClick
  }, restProps), /*#__PURE__*/React.createElement(Arrow, {
    $customColor: navigationBackLinkCustomColor,
    $onColor: onColor
  }), /*#__PURE__*/React.createElement(TextAtm, {
    typography: "xsmall1"
  }, text));
}
export default BackLinkAtm;